import { AbstractControl } from '@angular/forms';
import * as moment from 'moment';
import { Moment } from 'moment';
/**
 * Angular bootstrap Date adapter
 */
import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { retry } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
// ----------------------------------------
// General Alerts
// ----------------------------------------
export class AlertMessage {
  Message: string;
  AlertType: string;
}

export class AlertMessages {
  alertMessages: AlertMessage[] = [];
  constructor() {

  }
  setAlerts(alerts: AlertMessage[]) {
    this.alertMessages = alerts;
  }

  clearAll() { this.alertMessages = []; }

  addMessage(message: AlertMessage) {
    this.alertMessages.push(message);
  }

  hasAlerts() { return this.alertMessages.length > 0; }

  getAlertByType(alt_type: string): AlertMessage[] {
    return this.alertMessages.filter(r => r.AlertType.toLowerCase() == alt_type.toLowerCase());
  }
}


export class DDLDisplayItem {
  DisplayText: string;
  DisplayValue: number;
  AssociatedColumn?: string;
  Checked?: boolean;
}
export class IDateInterface {
  day: number;
  month: number;
  year: number;
}

export class DDLSelect {
  list: DDLDisplayItem[];
  isLoading: boolean = false;
  input: string = '';
  selected: any;
  public trackByFn(item: DDLDisplayItem) { return item.DisplayValue; }
}


//new code to handle long lists and it's dynamic// 
export class DDLSelect2 {
  items$: any[] = [];
  itemsBuffer$?: Observable<any>;
  input$ = new Subject<string>();
  selectedValue?: any = 0;
  asyncSearch?: any;

  list: DDLDisplayItem[]; //added this to display the items - new
  input: string = ''; // new

  searchTerm$: string = '';
  bindLabel: string = 'DisplayText'
  bindValue: string = 'DisplayValue'
  isLoading: boolean = false;
  virualScroll: boolean = true;
  placeholder: string = 'Select Options';
  formControlName: string = '';

  public trackByFn(item: DDLDisplayItem) { return item.DisplayValue; } // new

}
/////////



export class ListSelect<T> {
  list: T[];
  isLoading: boolean = false;
  input: string = '';
  selected: T;
  public trackByFn(item: T) { return item; }
}
 



 

@Injectable()
export class NgbDateMomentAdapter extends NgbDateAdapter<Moment> {
  fromModel(date: Moment): NgbDateStruct {
        if (date != null && moment.isMoment(date) && date.isValid()) {
            return { year: date.year(), month: date.month() + 1, day: date.date() };
        }
        return null;
    }

    toModel(date: NgbDateStruct): Moment {
        return date ? moment(date.year + '-' + date.month + '-' + date.day, 'YYYY-MM-DD') : null;
    }
}

export class DeepCopy {
  static naiveDeepCopy(original: any) {
  // First create an empty object with
  // same prototype of our original source
  var clone = Object.create(Object.getPrototypeOf(original));

  var i, descriptor, keys = Object.getOwnPropertyNames(original);

  for (i = 0; i < keys.length; i++) {
    // Save the source's descriptor
    descriptor = Object.getOwnPropertyDescriptor(original, keys[i]);

    if (descriptor.value && typeof descriptor.value === 'object') {
      // If the value is an object, recursively deepCopy() it
      descriptor.value = DeepCopy.naiveDeepCopy(descriptor.value);
    }

    Object.defineProperty(clone, keys[i], descriptor);
  }

  return clone;
}

}
